import { Modal, Dropdown } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";

import searchicon from "../../../assets/images/ic_search.svg";
import ic_search_dark from "../../../assets/images/ic_search_dark.svg";
import Up_arrow_white from "../../../assets/images/Up_arrow_white.svg";
import downarrow from "../../../assets/images/ic_down_green.svg";
import optionIcon from "../../../assets/images/optionDot.svg";
import { AppContext } from "../../../context/AppContext";
import Moment from "react-moment";
import { BeatLoader, ScaleLoader } from "react-spinners";
import ReportTabs from "../../../sharedComponent/ReportTabs";
import DarkCross from "../../../assets/images/close_modal.svg";
import LightCross from "../../../assets/images/close_modal_dark.svg";
import editIcon from "../../../assets/images/editIcon.svg";
import ReactPaginate from "react-paginate";
import {
  PostCallWithAuthToken,
  postMultipartWithAuthCallWithErrorResponse,
  postWithAuthCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import QRCode from "react-qr-code";
import close_modal from "../../../assets/images/close_modal.svg";
import close_modal_dark from "../../../assets/images/close_modal_dark.svg";
import ic_upload from "../../../assets/images/ic_upload.svg";
import ic_upload_dark from "../../../assets/images/ic_upload_dark.svg";
import Logo from "../../../assets/images/custom-rb-logo.png";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { isEmptyObject } from "../../../common";
import commaNumber from "comma-number";
import { ToWords } from "to-words";
import BootstrapSpinner from "../../../sharedComponent/BootstrapSpinner";
import dropdownicon from "../../../assets/images/drop-down-threedots-svg.svg";
import GoodsInvoiceView from "../../../component/Sales/GoodsInvoiceView";
import { formatCurrency } from "../../../common";
import GoodsPrintView from "../../../component/Sales/GoodsPrintView";
import FileSaver from "file-saver"

const SalesGoodsList = (props) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [innermenu, setinnermenu] = useState(false);
  const [innermenu2, setinnermenu2] = useState(false);
  const [date, setDate] = useState(false);
  const [company, setCompany] = useState(false);
  const [option, setOption] = useState(false);
  const [allSalesInvoices, setAllSalesInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUsersPerPage] = useState(5);
  const [searchValue, setSearchValue] = useState("");
  const { sidebar, Dark, appSettings } = useContext(AppContext);
  const [previewTaxInvoiceData, setPreviewTaxInvoiceData] = useState({});
  const [isView, setIsView] = useState(false);
  const [previewLoader, setPreviewLoader] = useState(false);

  const [printModal, setPrintModal] = useState(false);
  const [print, setPrint] = useState(false);
  const innerlist = () => {
    setinnermenu(!innermenu);
    setinnermenu2(false);
  };
  const chnagviwe = () => {
    setinnermenu2(!innermenu2);
    setinnermenu(false);
  };
  const handeldate = () => {
    setDate(true);
  };
  const dateclose = () => {
    setDate(false);
  };
  const compantShow = () => {
    setCompany(true);
  };
  const companyClose = () => {
    setCompany(false);
  };
  const optionshow = () => {
    setOption(!option);
  };

  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getAllSalesInvoices();
  }, []);

  const getAllSalesInvoices = () => {
    setLoading(true);
    simpleGetCallWithToken(ApiConfig.GET_SALES_GOODS_INVOICE_LIST)
      .then((res) => {
        console.log(res);
        if (res.success) {
          setAllSalesInvoices(res.data);
        } else {
          console.log("error response,", res);
        }
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const startIndex = currentPage * usersPerPage;

  let endIndex = startIndex + parseInt(usersPerPage);

  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };

  const pageSizeHandler = (e) => {
    setUsersPerPage(e.target.value);
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(allSalesInvoices?.length / usersPerPage);

  const searchedDataPageCounts =
    allSalesInvoices &&
    allSalesInvoices.length &&
    allSalesInvoices.filter((item) =>
      item.particular?.toLowerCase().includes(searchValue)
    );

  const getInvoiceEditData = (invoiceId) => {
    simpleGetCallWithToken(
      ApiConfig.GET_SALES_INVOICE_TAX_DATA + `/${invoiceId}`
    )
      .then((res) => {
        if (res.data !== null) {
          navigate("/SalesGoods", {
            state: { invoiceData: res.data, action: "edit" },
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const getTaxInvoiceData = (invoiceId, actionType) => {
    invoiceId && invoiceId && setPreviewLoader(true);
    simpleGetCallWithToken(
      ApiConfig.GET_SALES_INVOICE_TAX_DATA + `/${invoiceId}`
    )
      .then((res) => {
        if (res.data !== null) {
          setPreviewTaxInvoiceData(res.data);
          if (actionType.includes("view")) {
            setIsView(true);
          } else if (actionType.includes("print")) {
            setPrint(true);
          }
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setPreviewLoader(false);
      });
  };

  const displaySalesinvoices = allSalesInvoices
    ?.slice(startIndex, endIndex)
    .map((invoice, index) => {
      return (
        <tbody>
          <tr
            key={"displaySalesinvoices" + index}
            className="table-row-custom salesList"
            style={{ height: "50px" }}
          >
            <td>{startIndex + index + 1}</td>
            <td>
              <Moment format="DD/MM/YYYY">{invoice.invoiceDate}</Moment>
            </td>
            <td>{invoice.particular}</td>
            <td>{invoice.invoiceType}</td>
            <td>{invoice.invoiceNo}</td>
            {/* <Dropdown className="dropdown-container">
              <Dropdown.Toggle id="dropdown-basic" className="dropdown-btn">
                <td>{invoice.invoiceNo}</td>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="dropdown-list-item"
                style={{ background: "" }}
              >
                <Dropdown.Item
                  onClick={() => {
                    setPrint(true);
                    getTaxInvoiceData(invoice.id, "print");
                  }}
                >
                  Print
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    getTaxInvoiceData(invoice.id, "view");
                  }}
                >
                  View
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    getInvoiceEditData(invoice.id, invoice.invoiceNo);
                  }}
                >
                  Edit
                </Dropdown.Item>
                <Dropdown.Item>Download</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
            {appSettings && appSettings.isGSTApplicable && (
              <td>{invoice.gstNo ? invoice.gstNo : "-"}</td>)}

            <td>
              {invoice.grossTotal ? formatCurrency(invoice.grossTotal) : ""}
            </td>
            {appSettings && appSettings.isGSTApplicable && (
              <td>
                {invoice.igst
                  ? formatCurrency(invoice.igst)
                  : formatCurrency(invoice.sgst + invoice.cgst)}
              </td>)}

            <td>
              {/* <img
                src={editIcon}
                alt="edit icon"
                onClick={() => {
                  getInvoiceEditData(invoice.id, invoice.invoiceNo);
                }}
              /> */}
              <Dropdown className="dropdown-container">
                <Dropdown.Toggle id="dropdown-basic">
                  <img src={dropdownicon} alt="action im" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-list-item">
                  <Dropdown.Item
                    onClick={() => {
                      setPrint(true);
                      getTaxInvoiceData(invoice.id, "print");
                    }}
                  >
                    Print
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      getTaxInvoiceData(invoice.id, "view");
                    }}
                  >
                    View
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      getInvoiceEditData(invoice.id, invoice.invoiceNo);
                    }}
                  >
                    Edit
                  </Dropdown.Item>
                  <Dropdown.Item>Download</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* dropdownicon */}
            </td>
          </tr>
        </tbody>
      );
    });

  const displaySearchedInvoices = allSalesInvoices
    ?.filter((item) => item.particular &&
      (item.particular.toUpperCase().includes(searchValue.toUpperCase()) ||
        item.particular.toLowerCase().includes(searchValue.toLowerCase())))
    .slice(startIndex, endIndex)
    .map((invoice, index) => {
      return (
        <tr
          key={"displaySearchedInvoices" + index}
          className="table-row-custom salesList"
          style={{ height: "50px" }}
        >
          <td>{startIndex + index + 1}</td>
          <td>
            <Moment format="DD/MM/YYYY">{invoice.invoiceDate}</Moment>
          </td>
          <td>{invoice.particular}</td>
          <td>{invoice.invoiceType}</td>
          <td>{invoice.invoiceNo}</td>
          {appSettings && appSettings.isGSTApplicable && (
            <td>{invoice.gstNo ? invoice.gstNo : "-"}</td>)}


          <td>
            {invoice.grossTotal ? formatCurrency(invoice.grossTotal) : ""}
          </td>
          {appSettings && appSettings.isGSTApplicable && (
            <td>
              {invoice.igst
                ? formatCurrency(invoice.igst)
                : formatCurrency(invoice.sgst + invoice.cgst)}
            </td>)}
          <td>
            {/* <img
              src={editIcon}
              alt="edit icon"
              onClick={() => {
                getInvoiceEditData(invoice.id, invoice.invoiceNo);
              }}
            /> */}
            <Dropdown className="dropdown-container">
              <Dropdown.Toggle id="dropdown-basic" className="dropdown-btn">
                <img src={dropdownicon} alt="action im" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-list-item">
                <Dropdown.Item>Print</Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    getTaxInvoiceData(invoice.id);
                  }}
                >
                  View
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    getInvoiceEditData(invoice.id, invoice.invoiceNo);
                  }}
                >
                  Edit
                </Dropdown.Item>
                <Dropdown.Item>Download</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </td>
        </tr>
      );
    });

  const downLoadExcelFile = async () => {
    try {
      const res = await simpleGetCallWithToken(ApiConfig.DOWNLOAD_EXCEL_SALES_GOODS)
      console.log("res,", res)
      // Convert base64 to Blob
      const byteCharacters = atob(res.excelBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Save the Blob as a file
      FileSaver.saveAs(blob, 'GoodsInvoice List.xlsx');
      // if(res && res.success){
      // FileSaver.saveAs(
      // "data:" + res.excelBase64 + ";base64," + "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      // "Sales Goods List"
      // );
      // notifySuccess("Excel sheet download successfully")
      // }


    } catch (error) {
      console.log("Catch error from downLoadExcelFile,", error)
    }
  }

  return (
    <div>
      <div
        id="cx-main"
        className={sidebar ? "salesReportMain" : "cx-active salesReportMain"}
      >
        <div className="role-content">
          <div>
            <div className="sub-header-role reportSaleHEader">
              <h6 className="mt-2"> Goods Invoices </h6>
            </div>
          </div>

          <div className="d-flex justify-content-between role-searchbar-and-btns RspSalary">
            <div className="role-table-header">
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Search"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setCurrentPage(0);
                    setUsersPerPage(5);
                  }}
                />

                {Dark === "lightMode" ? (
                  <img src={searchicon} alt="" />
                ) : (
                  <img src={searchicon} alt="" />
                )}
              </div>
              <div className="entries-wrapper">
                <p>Entries per page</p>
                <select
                  className="form-select select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => pageSizeHandler(e)}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                </select>
              </div>
            </div>

            <div className="role-btns-wrapper">
              {/* <button onClick={handleShow}>
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.1441 13.8031V14.7551C14.1401 14.8514 14.1163 14.9458 14.0741 15.0324C14.0319 15.119 13.9723 15.196 13.899 15.2585C13.8256 15.321 13.7402 15.3677 13.648 15.3957C13.5558 15.4237 13.4588 15.4323 13.3631 15.4211H0.929138C0.838264 15.4317 0.746169 15.4219 0.659545 15.3925C0.57292 15.3631 0.49394 15.3147 0.428344 15.2509C0.362747 15.1871 0.31218 15.1095 0.280317 15.0238C0.248454 14.938 0.236095 14.8462 0.244138 14.7551V5.3551C0.235395 5.25736 0.246286 5.15886 0.27617 5.06539C0.306054 4.97192 0.354328 4.88538 0.418152 4.81084C0.481975 4.7363 0.56006 4.67528 0.647814 4.63136C0.735567 4.58744 0.831217 4.56151 0.929138 4.5551H3.15714C3.3591 4.5551 3.55279 4.63533 3.6956 4.77814C3.83841 4.92095 3.91864 5.11464 3.91864 5.3166C3.91864 5.51857 3.83841 5.71226 3.6956 5.85507C3.55279 5.99787 3.3591 6.0781 3.15714 6.0781H1.76714V13.9021H12.6181V13.8021C12.6181 13.6001 12.6984 13.4065 12.8412 13.2636C12.984 13.1208 13.1777 13.0406 13.3796 13.0406C13.5816 13.0406 13.7753 13.1208 13.9181 13.2636C14.0609 13.4065 14.1411 13.6001 14.1411 13.8021L14.1441 13.8031ZM17.5331 6.7031L12.8121 11.5191C12.7052 11.6276 12.5684 11.7018 12.4192 11.7322C12.2699 11.7627 12.115 11.748 11.9741 11.6901C11.8288 11.6329 11.7039 11.5334 11.6157 11.4046C11.5275 11.2757 11.4799 11.1233 11.4791 10.9671V8.8911C9.95614 8.8531 6.30114 9.0051 4.96814 11.3471C4.90263 11.4669 4.80641 11.5671 4.68936 11.6374C4.57232 11.7077 4.43866 11.7456 4.30214 11.7471C4.23821 11.7502 4.17419 11.7438 4.11214 11.7281C3.94873 11.6842 3.8043 11.5878 3.70111 11.4537C3.59792 11.3196 3.54171 11.1553 3.54114 10.9861C3.59838 9.02185 4.38353 7.14896 5.74414 5.7311C7.27785 4.23876 9.33419 3.4051 11.4741 3.4081V1.3331C11.4759 1.18256 11.522 1.03587 11.6067 0.911378C11.6913 0.78688 11.8108 0.690091 11.9501 0.633103C12.094 0.574261 12.252 0.559099 12.4044 0.58951C12.5568 0.619922 12.6969 0.694559 12.8071 0.804103L17.5471 5.6201C17.6858 5.76716 17.7615 5.96249 17.7584 6.16456C17.7552 6.36662 17.6733 6.55947 17.5301 6.7021L17.5331 6.7031Z"
                    fill="#3DA298"
                  />
                </svg>
              </button> */}
              <button>
                {" "}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={downLoadExcelFile}
                >
                  <path
                    d="M12.5901 17.2281C12.5721 17.2294 12.5541 17.2294 12.5361 17.2281L3.02012 15.8691C2.84089 15.8433 2.67681 15.7542 2.55758 15.6179C2.43835 15.4816 2.37185 15.3072 2.37012 15.1261V2.86911C2.37111 2.68741 2.43725 2.5121 2.55653 2.37502C2.6758 2.23794 2.8403 2.14821 3.02012 2.12211L12.5351 0.769115C12.5885 0.761859 12.6428 0.765946 12.6945 0.78111C12.7462 0.796274 12.7941 0.822173 12.8351 0.857115C12.8759 0.892567 12.9086 0.936351 12.931 0.985515C12.9535 1.03468 12.9651 1.08808 12.9651 1.14211V16.8511C12.9646 16.9508 12.9247 17.0463 12.8541 17.1168C12.7834 17.1872 12.6879 17.2269 12.5881 17.2271L12.5901 17.2281ZM7.40912 10.4801L8.42012 12.2801H9.93912L8.17012 9.13111L9.93912 5.98511H8.42112L7.40912 7.78511L6.39712 5.98511H4.87812L6.64912 9.13111L4.87812 12.2771H6.39712L7.40812 10.4771L7.40912 10.4801ZM16.7521 15.7801H13.7241V14.2691H15.9941V3.72411H13.7241V2.21811H16.7511C16.9513 2.21785 17.1434 2.29697 17.2853 2.43813C17.4272 2.57928 17.5073 2.77096 17.5081 2.97111V15.0251C17.5076 15.2253 17.4277 15.417 17.286 15.5584C17.1443 15.6997 16.9523 15.7791 16.7521 15.7791V15.7801Z"
                    fill="#53B7E8"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="table-wrapper">
            {loading ? (
              <div>
                <div className="center-spinner d-flex justify-between-center">
                  <ScaleLoader color="#53B7E8" className="spinner" />
                </div>
              </div>
            ) : allSalesInvoices && allSalesInvoices.length > 0 ? (
              <table>
                <tbody>
                  <tr className="firstTabelRow">
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Particular</th>
                    <th>Voucher Type</th>
                    <th>Voucher Ref. No.</th>
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GSTIN/UIN</th>)}

                    <th>Gross Total</th>
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales</th>)}

                    <th>Action</th>
                  </tr>
                </tbody>
                {searchValue === ""
                  ? displaySalesinvoices
                  : displaySearchedInvoices}
              </table>
            ) : (
              <div
                style={{
                  color: "red",
                  textAlign: "center",
                }}
              >
                <p className="mt-5">No Records to Show </p>
              </div>
            )}
            <div className="row mt-4">
              <div className="col-lg-12">
                {!loading &&
                  Math.ceil(searchedDataPageCounts?.length / usersPerPage) >
                  1 && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      pageCount={
                        searchValue === ""
                          ? pageCount
                          : Math.ceil(
                            searchedDataPageCounts?.length / usersPerPage
                          )
                      }
                      onPageChange={changePage}
                      containerClassName={"paginationBttns"}
                      previousLinkClassName={"previousBttn"}
                      nextLinkClassName={"nextBttn"}
                      disabledClassName={"paginationDisabled"}
                      activeClassName={"paginationActive"}
                      forcePage={currentPage}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <GoodsInvoiceView
        previewTaxInvoiceData={previewTaxInvoiceData}
        isView={isView}
        setIsView={setIsView}
        previewLoader={previewLoader}
      />
      <GoodsPrintView
        previewTaxInvoiceData={previewTaxInvoiceData}
        printModal={printModal}
        setPrintModal={setPrintModal}
        print={print}
        setPrint={setPrint}
      />
    </div>
  );
};

export default SalesGoodsList;
